<template>
    <section
        ref="section22"
        :class="[
            Object.keys(validationErrors).length > 0 ? 'has-errors' : '',
            'mx-auto flex h-full flex-col',
        ]"
    >
        <v-add-listing-head :routes="routes" :step="12"></v-add-listing-head>
        <main class="flex h-full flex-col items-center justify-between overflow-y-auto px-4 py-8 md:px-12">
            <figure class="flex flex-col gap-11 lg:w-full">
                <v-error-display :validation-errors="validationErrors"></v-error-display>
                <figure class="ml-auto mr-auto flex max-w-lg gap-3">
                    <div><v-icon icon="house-check" size="8"></v-icon></div>
                    <div class="flex flex-col justify-center">
                        <div class="mb-3 mr-6 text-heading-3-desktop">
                            Izberite trajanje oglasa
                        </div>
                        <div class="text-body-regular text-black-40">
                            Izberete koliko časa bi radi, da je vaš oglas aktiven
                        </div>
                    </div>
                </figure>
                <figure class="flex justify-center gap-4 mt-12">
                    <div class="p-4 rounded-xl relative w-full lg:w-auto lg:min-w-[360px] cursor-pointer" @click="selectSubscription('90-free')"
                        :class="{
                            'bg-white shadow--big-blur': selected !== '90-free',
                            'bg-[#ECF2F1] shadow-inner': selected === '90-free'
                        }"
                    >
                        <div class="absolute -right-2 top-[-16px] z-20">
                            <div
                                class=" bg-green-50 text-small-text-medium text-white flex items-center gap-2 shadow--big-blur rounded-full px-4 py-2">
                                <v-icon icon="fire" class="h-5 w-5" />
                                <span>Samo do 1. 6. 2024</span>
                            </div>
                        </div>
                        <div class="bg-green-25 rounded-lg relative overflow-hidden">
                            <div class="absolute left-4 top-4 bg-green rounded-md px-5 py-2 text-heading-1-mobile z-10 text-white shadow--big-blur">
                                90 dni
                            </div>
                            <div class="absolute -right-10 -bottom-8 h-48 w-48">
                                <img src="/assets/images/hiska-1.webp" alt="">
                            </div>
                            <div class="w-full pb-12">
                                <svg width="100%" viewBox="0 0 326 147" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.24">
                                        <path
                                            d="M1.99819 2.49219H38.004C38.9161 2.49196 39.8026 2.79957 40.5255 3.36711C41.2484 3.93465 41.767 4.73024 42.0006 5.62993L77.5743 142.831V2.49219H90.8677C92.5746 2.49219 94.2648 2.83527 95.8418 3.50183C97.4188 4.1684 98.8517 5.1454 100.059 6.37706C101.266 7.60872 102.223 9.0709 102.876 10.6801C103.53 12.2894 103.866 14.0141 103.866 15.756V133.697C103.866 135.437 103.529 137.16 102.876 138.767C102.222 140.374 101.264 141.834 100.057 143.063C98.8491 144.292 97.4159 145.265 95.8391 145.928C94.2623 146.59 92.5729 146.929 90.8677 146.924H53.6881C52.771 146.924 51.8798 146.613 51.155 146.04C50.4301 145.466 49.9127 144.663 49.6842 143.757L15.2915 7.65073V146.976H1.99819C0.288703 146.98 -1.40484 146.64 -2.98493 145.974C-4.56502 145.309 -6.00045 144.33 -7.20857 143.096C-8.41669 141.862 -9.37364 140.396 -10.0243 138.783C-10.675 137.17 -11.0066 135.441 -10.9999 133.697V15.756C-10.9999 14.0141 -10.6637 12.2894 -10.0105 10.6801C-9.35727 9.0709 -8.39983 7.60872 -7.19285 6.37706C-4.75524 3.88962 -1.44912 2.49219 1.99819 2.49219Z"
                                            fill="url(#paint0_linear_5233_4333)" />
                                        <path
                                            d="M131.595 99.2616C131.595 98.5132 131.791 97.7785 132.162 97.1328C132.533 96.4872 133.065 95.9538 133.705 95.5874L181.952 67.8988C186.5 65.9871 190.448 62.841 193.368 58.8019C196.288 54.7628 198.068 49.9849 198.515 44.9866C198.515 36.5213 193.056 25.7927 176.674 25.7927C173.651 25.6029 170.624 26.0812 167.8 27.195C164.975 28.3088 162.419 30.0319 160.307 32.2464C158.195 34.4608 156.577 37.1146 155.562 40.0261C154.548 42.9377 154.161 46.0384 154.43 49.1164H133.417C132.85 49.1147 132.289 48.9944 131.77 48.7631C131.251 48.5318 130.783 48.1944 130.397 47.7716C130.01 47.3488 129.712 46.8497 129.522 46.305C129.332 45.7603 129.253 45.1815 129.29 44.6045C131.112 16.0488 150.325 0 176.681 0C209.648 0 225.829 21.6703 225.829 44.994C225.829 62.9534 217.533 76.1584 194.281 89.1576L136.671 121.145H228.09V142.727C228.09 143.281 227.983 143.829 227.775 144.341C227.568 144.853 227.263 145.318 226.879 145.71C226.496 146.101 226.04 146.412 225.538 146.624C225.037 146.836 224.499 146.945 223.957 146.945H135.721C135.178 146.945 134.641 146.836 134.139 146.624C133.638 146.412 133.182 146.101 132.798 145.71C132.414 145.318 132.11 144.853 131.902 144.341C131.694 143.829 131.587 143.281 131.587 142.727L131.595 99.2616Z"
                                            fill="url(#paint1_linear_5233_4333)" />
                                        <path
                                            d="M305.711 118.067H237.148V92.267L281.241 2.49219H318.687C322.215 2.49219 325.598 3.92213 328.092 6.46746C330.586 9.01278 331.988 12.465 331.988 16.0646V92.267H350.999V113.577C350.999 114.778 350.531 115.929 349.699 116.778C348.868 117.627 347.739 118.104 346.563 118.104H331.988V133.425C331.988 137.025 330.586 140.477 328.092 143.022C325.598 145.568 322.215 146.998 318.687 146.998H305.725L305.711 118.067ZM305.711 92.267V7.65073L264.664 92.267H305.711Z"
                                            fill="url(#paint2_linear_5233_4333)" />
                                    </g>
                                    <defs>
                                        <linearGradient id="paint0_linear_5233_4333" x1="46.4329" y1="2.49219" x2="46.4329"
                                            y2="146.976" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="white" stop-opacity="0.16" />
                                            <stop offset="1" stop-color="white" />
                                        </linearGradient>
                                        <linearGradient id="paint1_linear_5233_4333" x1="178.686" y1="0" x2="178.686"
                                            y2="146.945" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="white" stop-opacity="0.16" />
                                            <stop offset="1" stop-color="white" />
                                        </linearGradient>
                                        <linearGradient id="paint2_linear_5233_4333" x1="294.074" y1="2.49219" x2="294.074"
                                            y2="146.998" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="white" stop-opacity="0.16" />
                                            <stop offset="1" stop-color="white" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                        <div class="p-2 mt-2 flex flex-col gap-3">
                            <p class="text-black-78 text-heading-4-bold">Objava oglasa za 90 dni</p>
                            <p class="text-green text-heading-1-mobile">brezplačno</p>
                            <p class="text-[#BFBFBF] text-small-text-medium">redna cena po izteku akcije: <span class="text-black-40">45,90€</span></p>
                        </div>
                    </div>
                    <div class="p-4 rounded-xl relative w-full lg:w-auto lg:min-w-[360px] cursor-pointer" @click="selectSubscription('draft')"
                        :class="{
                            'bg-white shadow--big-blur': selected !== 'draft',
                            'bg-[#ECF2F1] shadow-inner': selected === 'draft'
                        }"
                    >
                        <div class="bg-green-25 rounded-lg relative overflow-hidden">
                            <div class="w-full pb-12">
                                <svg width="100%" viewBox="0 0 326 147" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.24">
                                        <path
                                            d="M1.99819 2.49219H38.004C38.9161 2.49196 39.8026 2.79957 40.5255 3.36711C41.2484 3.93465 41.767 4.73024 42.0006 5.62993L77.5743 142.831V2.49219H90.8677C92.5746 2.49219 94.2648 2.83527 95.8418 3.50183C97.4188 4.1684 98.8517 5.1454 100.059 6.37706C101.266 7.60872 102.223 9.0709 102.876 10.6801C103.53 12.2894 103.866 14.0141 103.866 15.756V133.697C103.866 135.437 103.529 137.16 102.876 138.767C102.222 140.374 101.264 141.834 100.057 143.063C98.8491 144.292 97.4159 145.265 95.8391 145.928C94.2623 146.59 92.5729 146.929 90.8677 146.924H53.6881C52.771 146.924 51.8798 146.613 51.155 146.04C50.4301 145.466 49.9127 144.663 49.6842 143.757L15.2915 7.65073V146.976H1.99819C0.288703 146.98 -1.40484 146.64 -2.98493 145.974C-4.56502 145.309 -6.00045 144.33 -7.20857 143.096C-8.41669 141.862 -9.37364 140.396 -10.0243 138.783C-10.675 137.17 -11.0066 135.441 -10.9999 133.697V15.756C-10.9999 14.0141 -10.6637 12.2894 -10.0105 10.6801C-9.35727 9.0709 -8.39983 7.60872 -7.19285 6.37706C-4.75524 3.88962 -1.44912 2.49219 1.99819 2.49219Z"
                                            fill="url(#paint0_linear_5233_4333)" />
                                        <path
                                            d="M131.595 99.2616C131.595 98.5132 131.791 97.7785 132.162 97.1328C132.533 96.4872 133.065 95.9538 133.705 95.5874L181.952 67.8988C186.5 65.9871 190.448 62.841 193.368 58.8019C196.288 54.7628 198.068 49.9849 198.515 44.9866C198.515 36.5213 193.056 25.7927 176.674 25.7927C173.651 25.6029 170.624 26.0812 167.8 27.195C164.975 28.3088 162.419 30.0319 160.307 32.2464C158.195 34.4608 156.577 37.1146 155.562 40.0261C154.548 42.9377 154.161 46.0384 154.43 49.1164H133.417C132.85 49.1147 132.289 48.9944 131.77 48.7631C131.251 48.5318 130.783 48.1944 130.397 47.7716C130.01 47.3488 129.712 46.8497 129.522 46.305C129.332 45.7603 129.253 45.1815 129.29 44.6045C131.112 16.0488 150.325 0 176.681 0C209.648 0 225.829 21.6703 225.829 44.994C225.829 62.9534 217.533 76.1584 194.281 89.1576L136.671 121.145H228.09V142.727C228.09 143.281 227.983 143.829 227.775 144.341C227.568 144.853 227.263 145.318 226.879 145.71C226.496 146.101 226.04 146.412 225.538 146.624C225.037 146.836 224.499 146.945 223.957 146.945H135.721C135.178 146.945 134.641 146.836 134.139 146.624C133.638 146.412 133.182 146.101 132.798 145.71C132.414 145.318 132.11 144.853 131.902 144.341C131.694 143.829 131.587 143.281 131.587 142.727L131.595 99.2616Z"
                                            fill="url(#paint1_linear_5233_4333)" />
                                        <path
                                            d="M305.711 118.067H237.148V92.267L281.241 2.49219H318.687C322.215 2.49219 325.598 3.92213 328.092 6.46746C330.586 9.01278 331.988 12.465 331.988 16.0646V92.267H350.999V113.577C350.999 114.778 350.531 115.929 349.699 116.778C348.868 117.627 347.739 118.104 346.563 118.104H331.988V133.425C331.988 137.025 330.586 140.477 328.092 143.022C325.598 145.568 322.215 146.998 318.687 146.998H305.725L305.711 118.067ZM305.711 92.267V7.65073L264.664 92.267H305.711Z"
                                            fill="url(#paint2_linear_5233_4333)" />
                                    </g>
                                    <defs>
                                        <linearGradient id="paint0_linear_5233_4333" x1="46.4329" y1="2.49219" x2="46.4329"
                                            y2="146.976" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="white" stop-opacity="0.16" />
                                            <stop offset="1" stop-color="white" />
                                        </linearGradient>
                                        <linearGradient id="paint1_linear_5233_4333" x1="178.686" y1="0" x2="178.686"
                                            y2="146.945" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="white" stop-opacity="0.16" />
                                            <stop offset="1" stop-color="white" />
                                        </linearGradient>
                                        <linearGradient id="paint2_linear_5233_4333" x1="294.074" y1="2.49219" x2="294.074"
                                            y2="146.998" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="white" stop-opacity="0.16" />
                                            <stop offset="1" stop-color="white" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                        <div class="p-2 mt-2 flex flex-col gap-3">
                            <p class="text-black-78 text-heading-4-bold">Shrani kot osnutek</p>
                            <p class="text-green text-heading-1-mobile">Brezplačno</p>
                            <p class="text-[#BFBFBF] text-small-text-medium">Oglas lahko aktivirate kasneje</p>
                        </div>
                    </div>
                </figure>
            </figure>
            <form
                method="POST"
                :action="routes.submitForm"
                id="payment_form"
                class="hidden"
            >
                <v-csrf-token></v-csrf-token>
                <input type="hidden" name="subscription_type" v-model="selected">
            </form>
        </main>
        <v-add-listing-foot>
            <a
                :href="routes.previousStep ? routes.previousStep : '/'"
                class="button button--white button--md h-[48px] w-[240px] px-6 mr-4"
            >
                <v-icon icon="arrow-right" class="rotate-180" size="4"></v-icon>
                <label class="text-small-text-medium">Nazaj</label>
            </a>
            <a
                @click="submitForm('payment_form')"
                :class="[
                    'button button--md h-[48px] w-[240px] px-6',
                    validated ? '' : 'button button--gray',
                ]"
            >
                <label class="text-small-text-medium">Nadaljujte</label>
                <v-icon icon="arrow-right" size="4"></v-icon>
            </a>
        </v-add-listing-foot>
    </section>
</template>
<script>
import AddListingFootVue from "../AddListingFoot.vue";
import AddListingHeadVue from "../AddListingHead.vue";
import ErrorDisplay from '../ErrorDisplay.vue';

export default {
    components: {
        "v-add-listing-foot": AddListingFootVue,
        "v-add-listing-head": AddListingHeadVue,
        "v-error-display": ErrorDisplay
    },
    props: {
        old: {
            type: Object,
            required: false,
            default: {},
        },
        routes: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        stepData: {
            type: Object,
            required: true,
            default: {},
        },
    },
    data() {
        return {
            selected: '',
            loading: false,
        };
    },
    mounted() {},
    computed: {
        validated() {
            return this.selected != '';
        }
    },
    methods: {
        selectSubscription(subscription) {
            this.selected = subscription;
        },
        activateListing() {
            if(this.selected === '')
                return;

           this.loading = true;

           let headers = {
               headers: {
                  "X-CSRF-TOKEN": this.$csrfToken,
               },
            }

            axios.post(this.activateUrl, {subscription: this.selected}, headers)
                .then((response) => {
                    window.location = this.listingActivatedUrl
                },(error) => {
                  console.log(error)
                  this.loading = false;
            });
        },
        submitForm(formId) {
            document.getElementById(formId).submit();
        },
    },
};
</script>
